import { Link, useNavigate } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  showHome?: boolean;
}

export default function Breadcrumb({ items, showHome = true }: BreadcrumbProps) {
  const navigate = useNavigate();

  return (
    <nav className="flex items-center gap-2 text-sm mb-6">
      {showHome && (
        <>
          <button
            onClick={() => navigate('/waba')}
            className="flex items-center gap-1 text-text-3 hover:text-accent-1 transition-colors"
            title="Voltar para ambientes"
          >
            <Home size={16} />
            <span>Ambientes</span>
          </button>
          {items.length > 0 && <ChevronRight size={16} className="text-text-3" />}
        </>
      )}

      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <div key={index} className="flex items-center gap-2">
            {item.path ? (
              <Link
                to={item.path}
                className="text-text-3 hover:text-accent-1 transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? 'text-text-1 font-medium' : 'text-text-3'}>
                {item.label}
              </span>
            )}
            {!isLast && <ChevronRight size={16} className="text-text-3" />}
          </div>
        );
      })}
    </nav>
  );
}
